import { render } from "./addBusiness.vue?vue&type=template&id=4e2e8065&scoped=true"
import script from "./addBusiness.vue?vue&type=script&lang=js"
export * from "./addBusiness.vue?vue&type=script&lang=js"

import "./addBusiness.vue?vue&type=style&index=0&id=4e2e8065&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_xMds/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2e8065"]])

export default __exports__